<ng-container *ngIf="showNativeRedactionMessage; else checkManual">
    <span style="margin: 8px; height: 28px; display: flex; justify-content: center;"><b>Redaction Editor is disabled with Native Redacted file.</b></span>
</ng-container>
<ng-template #checkManual>
    <ng-container *ngIf="showManualMessage; else list_template">
        <span style="margin: 8px; height: 28px; display: flex; justify-content: center;"><b>Viewing manually uploaded redacted file.</b></span>
    </ng-container>
</ng-template>
<ng-template #list_template>
    <div *ngFor="let page of pageRedactionMap; trackBy: trackByPageNumber">
        <lex-doc-viewer-coding-section panelId="expandable-redaction-panel-page-{{page.pageNum}}" class="expander">
            <div coding-section-title
                style="min-height: 36px; min-height: 36px; align-items: center; display: flex; width:100%">
                <div style="display:flex; justify-content: space-between; width:100%;">
                    <div>Page {{page.pageNum}}</div>
                    <div style="margin-right: 10px;">{{getActiveRedactionCount(page.redactions)}}</div>
                </div>
            </div>
            <div *ngFor="let redaction of page.redactions; trackBy: trackById"
                [ngClass]="{'selected-edit': currentRedactionId === redaction.clientId}"
                style="height: 32px; padding: 8px; display:flex;" class="edit">
                <div (mouseenter)="setSelectedRedaction(redaction.clientId)"
                    style="display:flex; align-items: center; width: 100%;">
                    <div>
                        <div *ngIf="redaction.autoRedactionRuleId; else not_auto"
                            [matTooltip]="redaction.autoRedactionRule.ruleTitle" [matTooltipPosition]="'left'">
                            <i class="fa-duotone fa-bolt-auto icon"></i>
                        </div>
                        <ng-template #not_auto>
                            <i class="fa-duotone fa-circle-m icon"></i>
                        </ng-template>
                    </div>
                    <div style="width: 85%; height: 100%; margin-left: 6px; display: flex; align-items:center;">
                        <div *ngIf="redaction.clientId !== editItemTextId" (click)="setRedactionEditTextId(redaction)"
                            style="cursor: pointer; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                            <div *ngIf="redaction.text">
                                {{redaction.text}}
                            </div>
                            <div *ngIf="!redaction.text" matTooltip="Click to add text.">
                                <i class="fa-duotone fa-pen-to-square icon"></i>
                            </div>
                        </div>
                        <div *ngIf="redaction.clientId === editItemTextId"
                            style="display: flex; gap: 8px; width: 95%; align-items: center;">
                            <input placeholder="Text" [(ngModel)]="redaction.text" style="width: 100%;">
                            <div style="cursor: pointer;" (click)="setRedactionText(redaction)">
                                <i class="fa-duotone fa-check icon-alternate"></i>
                            </div>
                            <div (click)="cancelTextEdit(redaction)" style="cursor: pointer;">
                                <i class="fa-duotone fa-ban icon-alternate"></i>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="redaction.clientId !== editItemTextId"
                        style="display: flex; align-items: center; gap: 20px; margin-right: 16px;">
                        <div style="cursor: pointer;" (click)="editItemColorId = redaction.clientId"
                            [matMenuTriggerFor]="colorMenu">
                            <i class="fa-solid fa-circle" [style.color]="getBackGroundColor(redaction.highlightColor)"
                                style="font-size: 24px;border-radius: 50%; border: 1px solid lightgrey;"></i>
                        </div>
                        <mat-menu #colorMenu="matMenu">
                            <button mat-menu-item *ngFor="let color of redactionColors"
                                style="display: flex;align-items: center;justify-content: space-between;"
                                (click)="setColor(color, redaction)">
                                <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: flex-end;">
                                    <span>{{getColor(color)}}</span>
                                    <i class="fa-solid fa-rectangle-wide"[style.color]="getBackGroundColor(color.colorValue)"></i>
                                </div>
                            </button>
                        </mat-menu>
                        <div *ngIf="currentRedactionId === redaction.clientId" style="cursor: pointer;"
                            (click)="deleteRedaction(redaction);" matTooltip="Delete">
                            <i class="fa-solid fa-xmark icon-alternate"></i>
                        </div>
                        <div *ngIf="currentRedactionId !== redaction.clientId" style="min-width: 11px;"></div>
                    </div>
                </div>
            </div>
        </lex-doc-viewer-coding-section>
    </div>
</ng-template>